import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  appStatus: true,
  shopInfo: {
    domain: '',
    email: '',
    shopDomain: '',
    name: '',
    currency: '',
    moneyFormat: '',
    moneyWithFormat: '',
    shippingZones: '',
    timezone: '',
    shop_owner: ''
  },
  // Thanh toán
  currentPlan: {
    coupon_expired: false,
    price_name: 'FREE',
    version: 2
  },
  // Thanh toán
  countView: {
    view_total: 0,
    view_popup: 0,
    view_bundle: 0
  },

  statisticChart: {
    count_views_bundle: [],
    count_views_popup: [],
    date: []
  },

  viewByPlan: {
    last_date_charge: '2021-10-08',
    view_current: 26,
    view_limit: 1000,
    view_popup: 0,
    view_bundle: 0
  },

  listCampaignAll: [],
  listNotification: [],
  notificationsDetail: null,
  getPricingLoading: true,
  changeStatusLoading: false,
  deleteCampaignLoading: false,
  deleteCampaignResult: 0,
  isCountViewLoading: true
});

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_APP_STATUS:
      return state.set('appStatus', action.status).set('changeAppStatusLoading', true).set('changeAppStatusResult', 0);
    case types.CHANGE_APP_STATUS_RESULT:
      return state
        .set('appStatus', action.res.status)
        .set('changeAppStatusLoading', false)
        .set('changeAppStatusResult', action.res.result);
    case types.RESET_CHANGE_STATUS_APP_RESULT:
      return state.set('changeAppStatusResult', 0);
    case types.GET_LIST_NOTIFICATION_RESULT:
      return state.set('listNotification', fromJS(action.payload));
    case types.GET_NOTIFICATION_DETAIL_RESULT:
      return state.set('notificationsDetail', fromJS(action.payload[0]));
    // get shop info
    case types.GET_SHOP_INFO_RESPONSE:
      if (action.data && action.data.myshopify_domain && action.data.myshopify_domain.includes('.myshopify.com')) {
        window.fcWidget.user.setProperties({
          firstName: action.data.name,
          shopOwner: action.data.shop_owner,
          email: action.data.email,
          phone: action.data.phone,
          timezone: action.data.timezone,
          shop: action.data.myshopify_domain
        });
        const style = document.createElement('style');
        style.innerHTML = '#fc_frame{display: unset!important;}';
        document.body.appendChild(style);
      }
      return state
        .setIn(['shopInfo', 'domain'], action.data.domain)
        .setIn(['shopInfo', 'email'], action.data.email)
        .setIn(['shopInfo', 'shopDomain'], action.data.myshopify_domain)
        .setIn(['shopInfo', 'name'], action.data.name)
        .setIn(['shopInfo', 'timezone'], action.data.timezone)
        .setIn(['shopInfo', 'shop_owner'], action.data.shop_owner);
    case types.GET_CURRENCY_SHOP_RESPONSE:
      return state
        .setIn(['shopInfo', 'currency'], action.data.currency)
        .setIn(['shopInfo', 'moneyFormat'], action.data.money_format)
        .setIn(['shopInfo', 'moneyWithFormat'], action.data.money_with_currency_format);
    case types.GET_PRICING_PLAN:
      return state.set('getPricingLoading', true);
    case types.GET_PRICING_PLAN_RESULT:
      if (action.res) {
        return state
          .set('getPricingLoading', false)
          .set('currentPlan', fromJS(action.res))
          .set('appStatus', action.res.status_app);
      }
      return state.set('getPricingLoading', false);
    case types.GET_LIST_CAMPAIGN_ALL_RESULT:
      if (action.res) {
        return state.set('listCampaignAll', fromJS(action.res));
      }
      return state;

    // CHANGE STATUS CAMPAIGN
    case types.CHANGE_STATUS_UPSELL_CAMPAIGN:
      return state.set('changeStatusLoading', true);
    case types.CHANGE_STATUS_UPSELL_CAMPAIGN_RESULT:
      if (action.res) {
        return state
          .setIn(['listCampaignAll', action.payload.index, 'status'], action.payload.status)
          .set('changeStatusLoading', false);
      }
      return state.set('changeStatusLoading', false);

    // DELETE CAMPAIGN
    case types.DELETE_UPSELL_CAMPAIGN:
      return state.set('deleteCampaignLoading', true);
    case types.DELETE_UPSELL_CAMPAIGN_RESULT:
      return state.set('deleteCampaignLoading', false).set('deleteCampaignResult', action.res);
    case types.CHANGE_APP_REDUCER_FIELD:
      return state.set(action.payload.field, action.payload.value);
    case types.GET_COUNT_VIEW:
      return state.set('isCountViewLoading', true);
    case types.GET_COUNT_VIEW_RESULT:
      if (action.res) {
        return state.set('countView', fromJS(action.res)).set('isCountViewLoading', false);
      }
      return state.set('isCountViewLoading', false);
    case types.GET_STATISTIC_CHART_RESULT:
      if (action.res) {
        return state.set('statisticChart', fromJS(action.res));
      }
      return state;
    case types.GET_VIEW_BY_PLAN_RESULT:
      if (action.res) {
        return state.set('viewByPlan', fromJS(action.res));
      }
      return state;
    default:
      return state;
  }
};

export default appReducer;
